import { Component, OnInit, Input } from "@angular/core";
import { formatDate } from '@angular/common';

@Component({
  selector: "app-experience",
  templateUrl: "./experience.component.html",
  styleUrls: ["./experience.component.css"],
})
export class ExperienceComponent implements OnInit {
  constructor() {}

  @Input() experiences: string[];
  currentDate = formatDate(new Date(), 'yyyy-mm-dd', 'en-US');

  ngOnInit() {}
}
